/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable no-cond-assign */
/* eslint-disable multiline-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import { convertToSlug } from 'src/utils/IdGenerator'
import Image from 'next/image'
import { truncateToTwoWords } from '@utils/utils'
import { AckoMainTheme } from '@acko-tech/building-blocks.ui.theme'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import assetLoader from '@utils/internalImageLoader'
import styles from './quick-link2.module.scss'

const QuickLinkList = ({
  isToggle,
  showDropdown,
  setShowDropdown,
  isSticky,
  productPageResponse,
  activeSectionId,
  setIsToggle,
  setSelectedListItem,
  segmentEventCommonProperties,
  windowWidth,
  isQuickLinksVisible,
}) => {
  // Function to render list items
  const renderListItems = (contentSlice, startIdx, trupleValue) =>
    contentSlice.map((h2, index) => (
      <li
        key={index}
        className={`${styles.liLink}  ${isSticky && activeSectionId === convertToSlug(h2) ? styles.selectedLi : ''}`}
        onClick={() => {
          ;(async () => {
            const properties = await segmentEventCommonPropFunc(segmentEventCommonProperties)
            trackEvent('tap_btn_engage', {
              ...properties,
              funnel: 'engage',
            })
          })()

          // Handle click on list item
          // setActiveSectionId(convertToSlug(h2))
          setShowDropdown(false)
          setIsToggle(false)
          setSelectedListItem(h2)

          const element: any = document.querySelector(`#${convertToSlug(h2)}`)
          if (element) {
            // Scroll to the corresponding section smoothly
            if (isSticky) {
              window.scrollTo({ behavior: 'smooth', top: element?.offsetTop - 60 })
            } else {
              const quickLInk: any = document.getElementById('quickLinksSection')
              window.scrollTo({ behavior: 'smooth', top: element?.offsetTop - (quickLInk.offsetHeight + 40) })
            }
          }
        }}>
        {/* Link to the section */}
        {isQuickLinksVisible && (
          <Image
            src={`${assetLoader()}/images/quick-links-icon/link.svg`}
            className={styles.linkSvg}
            alt="link svg"
            loading="lazy"
            decoding="async"
            width={20}
            height={20}
          />
        )}
        {windowWidth > 768 && windowWidth <= 1070 && trupleValue && isSticky ? (
          <span>{truncateToTwoWords(h2)}</span>
        ) : (
          <span>{h2}</span>
        )}
      </li>
    ))

  // Extracting h2 contents from the product page response
  const h2Contents = productPageResponse?.[0]?.attributes.content.flatMap(item => {
    if (item.Content?.data) {
      const contentData = Array.isArray(item.Content.data) ? item.Content.data : [item.Content.data]
      return contentData.flatMap(contentItem => {
        const { sectionHeading, headerTabName, videoHeader, tableSectionHeading } = contentItem.attributes
        const h2Regex = /<h2[^>]*>(.*?)<\/h2>/g
        const h2Tags: any = []
        // Extract headerTabName if it exists, and use it instead of h2
        if (headerTabName) {
          h2Tags.push(headerTabName)
        } else if (sectionHeading) {
          const sectionH2Matches = sectionHeading.match(h2Regex)
          if (sectionH2Matches) {
            sectionH2Matches.forEach(match => h2Tags.push(match.replace(/<[^>]+>/g, '')))
          }
        } else if (videoHeader) {
          const videoMatch = h2Regex.exec(videoHeader)
          if (videoMatch !== null) h2Tags.push(videoMatch[1])
        } else if (tableSectionHeading) {
          const tableSectionMatch = h2Regex.exec(tableSectionHeading)
          if (tableSectionMatch !== null) h2Tags.push(tableSectionMatch[1])
        }

        return h2Tags
      })
    }
    return []
  })

  return (
    <div className={`${styles.ulBox} ${isToggle ? styles.show : ''} ${showDropdown ? styles.showDropdown : ''}`}>
      {/* First list */}
      {/* <ul>{renderListItems(h2Contents.slice(0, 4), 0)}</ul> */}

      {windowWidth > AckoMainTheme?.breakpoints?.m && windowWidth <= AckoMainTheme?.breakpoints?.l && isSticky ? (
        <ul>{renderListItems(h2Contents.slice(0, 3), 0, true)}</ul>
      ) : (
        <ul>{renderListItems(h2Contents.slice(0, 4), 0, false)}</ul>
      )}

      {/* Second list (dropdown) */}
      {windowWidth > AckoMainTheme?.breakpoints?.m && windowWidth <= AckoMainTheme?.breakpoints?.l && isSticky ? (
        <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
          {renderListItems(h2Contents.slice(3), 4, false)}
        </ul>
      ) : (
        <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
          {renderListItems(h2Contents.slice(4), 4, false)}
        </ul>
      )}
      {/* <ul className={`${styles.absolute} ${isToggle ? '' : styles.hidden}`}>
        {renderListItems(h2Contents.slice(4), 4)}
      </ul> */}
    </div>
  )
}

export default QuickLinkList
